export default __webpack_public_path__ + "static/video-mobile-fd661d707df7304eca9f3e510c610608.mp4";